import { RKColumns } from '@kite/react-kite/dist/grid/KiteGridCell/KiteGridCell';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import './InfographicCell.scss';

export type InfographicCellColorChoices =
    | `white`
    | `lt-gray`
    | `dk-gray`
    | `blue`;
export interface InfographicCellInputs {
    color: InfographicCellColorChoices;
    image?: any;
    imageAlt?: string;
    mainText?: string;
    subtext?: string;
    col: RKColumns;
    leadingImages?: {
        image: any;
        gImage?: any;
        alt: any;
    }[];
    trailingImages?: {
        image: any;
        gImage?: any;
        alt: any;
    }[];
}

export const InfographicCell = ({
    inputs,
}: {
    inputs: InfographicCellInputs;
}) => {
    const gImage = inputs.image ? getImage(inputs.image) : undefined;

    if (inputs.leadingImages) {
        for (const image of inputs.leadingImages) {
            image.gImage = getImage(image.image);
        }
    }

    if (inputs.trailingImages) {
        for (const image of inputs.trailingImages) {
            image.gImage = getImage(image.image);
        }
    }

    return (
        <section
            className={`infographic ${inputs.color} ${
                inputs.leadingImages ? `stackable` : ``
            }`}
        >
            {gImage && <GatsbyImage image={gImage} alt={inputs.imageAlt} />}
            {inputs.leadingImages && (
                <div className="leading-images">
                    {inputs.leadingImages.map((image, idx) => (
                        <GatsbyImage
                            key={idx}
                            className="large-image"
                            image={image.gImage}
                            alt={image.alt}
                        />
                    ))}
                </div>
            )}
            {!!inputs.mainText && (
                <div className="text">
                    <h3>{inputs.mainText}</h3>
                    {!!inputs.subtext && <p>{inputs.subtext}</p>}
                </div>
            )}
            {inputs.trailingImages && (
                <div className="trailing-images">
                    {inputs.trailingImages.map((image, idx) => (
                        <GatsbyImage
                            key={idx}
                            className="large-image"
                            image={image.gImage}
                            alt={image.alt}
                        />
                    ))}
                </div>
            )}
        </section>
    );
};
